import React from 'react'
import OfferCard from '../components/Cards/OfferCard'
import Navbar from './Navbar'
import Footer from '../components/layout/Footer'
const AllOffers = () => {
  return (
      <>
      <Navbar/>
      {/* dfsfsdf */}
        <div className='bg-slate-50 py-5 px-4'>
        <h1 className='text-xl font-bold px-2  md:px-28 md:py-8'>All Offers</h1>
        <div className='w-full grid md:grid-cols-3 grid-cols-1 px-2 md:px-24 gap-4'>
            <OfferCard image={'/images/Offer1.jpg'} content={'Get JioMart umbrella for Rs 129 on Grocery Shopping of Min. 500'}/>
            <OfferCard image={'/images/Offer2.jpg'} content={'AU - 10% Cashback Up to Rs. 500/-'}/>
            <OfferCard image={'/images/Offer3.jpg'} content={'Pay using Twid Pay with Rewards & Get up to Rs. 300/- Cashback.'} />
            <OfferCard image={'/images/offer4.jpg'} content={'Mobikwik - Pay using Mobikwik Wallet & Get up to Rs. 750/- Cashback.'} />
            <OfferCard image={'/images/offer5.jpg'} content={'Pay using Paytm Wallet & Get 5% Cashback up to Rs. 100/-'} />
            <OfferCard image={'/images/offer6.jpg'} content={'Get 5% Cashback Up to Rs. 1000/-'}/>
            <OfferCard image={'/images/Offer1.jpg'} content={'5% Cashback up to Rs 2,000 applicable on HDFC Bank Credit Cards & Credit Card EMI transactions.'}/>
            <OfferCard image={'/images/Offer3.jpg'} content={'Freecharge - Pay using Freecharge Wallet & Get Flat Rs. 40/- Cashback.'}/>
            <OfferCard image={'/images/Offer2.jpg'} content={'PAyZapp - 5% Cashback up to Rs. 50/-'}/>
        </div>
    </div>
    <Footer/>
      </>
  
  )
}

export default AllOffers